import { useEffect, useState } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Rooms } from "@/components/site/Rooms";
import { Amenities } from "@/components/site/Amenities";
import { Gallery } from "@/components/site/Gallery";
import { LocationSection } from "@/components/site/LocationSection";
import { Reviews } from "@/components/site/Reviews";
import { Footer } from "@/components/site/Footer";
import { BookingModal } from "@/components/site/BookingModal";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { ChatWidget } from "@/components/site/ChatWidget";
import api from "@/lib/api";

const todayStr = () => new Date().toISOString().split("T")[0];
const tomorrowStr = () => new Date(Date.now() + 86400000).toISOString().split("T")[0];

export default function Home({ dark, toggleTheme }) {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState({ checkIn: todayStr(), checkOut: tomorrowStr(), guests: 2 });
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    api.get("/rooms").then(({ data }) => setRooms(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleBook = (room) => { setSelectedRoom(room); setModalOpen(true); };

  return (
    <div className="min-h-screen bg-background">
      <Header dark={dark} toggleTheme={toggleTheme} />
      <Hero onSearch={setSearch} />
      <Rooms rooms={rooms} loading={loading} onBook={handleBook} />
      <Amenities />
      <Gallery />
      <LocationSection />
      <Reviews />
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <BookingModal room={selectedRoom} defaults={search} open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
